import { Newsletter } from 'ui/components/3-organisms/Newsletter';

export const NewsletterFeature: React.FC<Umbraco.Newsletter> = ({ content }) => {
	return <Newsletter {...content?.properties} />;
};
